import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { numberFormatAsked } from 'src/@core/utils/number-format-asked'
import { useRouter } from 'next/router'

interface Props {
  cycle: string
  kgCO2EqPV: number
  totalCO2eq: number
  totalCO2EqPerHead: number
  kgCO2Ha: number
  landId: number
}

export default function EmissionsCard({ kgCO2EqPV, totalCO2eq, totalCO2EqPerHead, kgCO2Ha, landId, cycle }: Props) {
  const router = useRouter()

  return (
    <Card
      className='rodeos-card'
      sx={{
        minWidth: '250px',
        height: '495px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white !important',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center' }}
            className='cards-title'
          >
            <Translations text={'Emission'} />
          </Typography>
          <Typography
            sx={{
              color: '#222',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 400,
              letterSpacing: '-0.28px',
              mb: '24px'
            }}
          >
            {cycle.replace('_', '/')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              textAlign: 'center',
              mb: '30px',
              padding: '10px'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '700', fontSize: '40px', pr: 2 }}>
              {numberFormatAsked(kgCO2EqPV)}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
              <Typography sx={{ color: 'black', fontWeight: '500', fontSize: '18px', pr: 2 }}>
                {'kgCO2eq/kg'}
              </Typography>
              <Typography sx={{ color: 'black', fontWeight: '700', fontSize: '12px', pr: 2 }}>
                <Translations text={'PV produced'} />
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '15px',
            backgroundColor: 'rgba(25, 118, 210, 0.20)',
            mt: '24px',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Total CO2 eq'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
              {numberFormatAsked(totalCO2eq)}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '15px',
            backgroundColor: 'rgba(25, 118, 210, 0.20)',
            mt: '24px',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Total CO2 eq per EV (Kg)'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            {totalCO2EqPerHead && (
              <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
                {numberFormatAsked(totalCO2EqPerHead)}
              </Typography>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '15px',
            backgroundColor: 'rgba(25, 118, 210, 0.20)',
            mt: '24px',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Kg CO2 eq/ha'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
              {numberFormatAsked(kgCO2Ha)}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: 'auto' }}>
          <Button
            variant='outlined'
            sx={{
              color: '#213D36',
              width: '123px',
              padding: '8px, 12px, 8px, 12px',
              fontSize: '16px',
              fontWeight: 700,
              borderRadius: '30px',
              border: '3px solid #213D36',
              mt: 'auto'
            }}
            onClick={() => router.push(`/lands/details/land/${landId}`)}
          >
            <Translations text={'See more'} />
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}
